import { useEffect, useState } from "react";
import { pos } from "@/platform";
import { puedeActualizar } from "@/context/caja/actualizacion";

/** Cada cuánto vuelve a mirar si ya se subieron las ventas. */
export const REVISAR_ACTUALIZACION_MS = 30_000;

/**
 * AC-E (#338): con ventas de la caja sin subir, la actualización espera, y el
 * aviso que bloquea la app aparece recién cuando se subieron. En la caja
 * arranca esperando, así el aviso no se asoma antes de la primera consulta.
 */
export function useActualizacionEnEspera(hayActualizacion: boolean): boolean {
  const [enEspera, setEnEspera] = useState(pos.isAvailable);
  useEffect(() => {
    if (!hayActualizacion) return;
    let vigente = true;
    const revisar = async () => {
      const puede = await puedeActualizar(pos);
      if (vigente) setEnEspera(!puede);
    };
    void revisar();
    const cada = setInterval(revisar, REVISAR_ACTUALIZACION_MS);
    return () => {
      vigente = false;
      clearInterval(cada);
    };
  }, [hayActualizacion]);
  return enEspera;
}
